'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var kea = require('kea');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function parseValue(value) {
  if (!Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
    value = Number(value);
  } else if (value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
    value = value.toLowerCase() === 'true';
  } else if (value.length >= 2 && (value.match(/^\[.*\] +$/) || value.match(/^\{.*\} +$/))) {
    value = value.substring(0, value.length - 1);
  } else if (value.length >= 2 && (value.match(/^\[.*\]$/) || value.match(/^\{.*\}$/))) {
    try {
      value = JSON.parse(value);
    } catch (e) {// well, damn
    }
  }

  return value;
}

function serializeValue(value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  } else if (typeof value === 'string' && (value.match(/^\[.*\] *$/) || value.match(/^\{.*\} *$/))) {
    value = value + ' ';
  }

  return value;
}

function decodeParams(input, symbol) {
  if (symbol && input.indexOf(symbol) === 0) {
    input = input.slice(1);
  }

  var ret = Object.create(null);

  for (var _iterator = input.split('&'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var param = _ref;
    param = param.replace(/\+/g, ' ');
    var index = param.indexOf('=');

    if (index === -1) {
      if (param.length > 0) {
        ret[decodeURIComponent(param)] = null;
      }
    } else {
      var key = decodeURIComponent(param.slice(0, index));
      var value = decodeURIComponent(param.slice(index + 1));
      ret[key] = parseValue(value);
    }
  }

  return ret;
}
function encodeParams(obj, symbol) {
  if (typeof obj !== 'object') {
    return '';
  }

  var string = Object.keys(obj).map(function (key) {
    var value = obj[key];

    if (typeof value === 'undefined') {
      return '';
    }

    if (value === null) {
      return encodeURIComponent(key);
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(serializeValue(value));
  }).filter(function (k) {
    return k.length !== 0;
  }).join('&');
  return string.length > 0 ? symbol + string : '';
}
function stringOrObjectToString(input, symbol) {
  if (!input) {
    return '';
  }

  return typeof input === 'object' ? encodeParams(input, symbol) : input.indexOf(symbol) === 0 ? input : '?' + input;
} // copied from react-router! :)

function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
var _e = encodeParams;
var _d = decodeParams;
function combineUrl(url, searchInput, hashInput, encodeParams, decodeParams) {
  if (encodeParams === void 0) {
    encodeParams = kea.getPluginContext('router').encodeParams || _e;
  }

  if (decodeParams === void 0) {
    decodeParams = kea.getPluginContext('router').decodeParams || _d;
  }

  var parsedPath = parsePath(url);
  var response = {
    pathname: parsedPath.pathname,
    search: undefined,
    // set below
    searchParams: decodeParams(parsedPath.search, '?'),
    hash: undefined,
    // set below
    hashParams: decodeParams(parsedPath.hash, '#')
  };

  if (typeof searchInput === 'object') {
    Object.assign(response.searchParams, searchInput);
  } else if (typeof searchInput === 'string') {
    Object.assign(response.searchParams, decodeParams(searchInput, '?'));
  }

  response.search = encodeParams(response.searchParams, '?');

  if (typeof hashInput === 'object') {
    Object.assign(response.hashParams, hashInput);
  } else if (typeof hashInput === 'string') {
    Object.assign(response.hashParams, decodeParams(hashInput, '#'));
  }

  response.hash = encodeParams(response.hashParams, '#');
  response.url = "" + response.pathname + response.search + response.hash;
  return response;
}

/*
Usage:

  kea({
    actionToUrl: ({ actions }) => ({
      [actions.selectEmail]: payload => `/signup/email`,
      [actions.unselectEmail]: payload => `/signup`
    }),

    urlToAction: ({ actions }) => ({
      '/signup/:type': ({ type }) => actions.selectEmail(),
      '/signup': () => actions.unselectEmail()
    }),
  })
*/

var router = kea.kea({
  path: function path() {
    return ['kea', 'router'];
  },
  actions: function actions() {
    return {
      push: function push(url, searchInput, hashInput) {
        return {
          url: url,
          searchInput: searchInput,
          hashInput: hashInput
        };
      },
      replace: function replace(url, searchInput, hashInput) {
        return {
          url: url,
          searchInput: searchInput,
          hashInput: hashInput
        };
      },
      locationChanged: function locationChanged(_ref) {
        var method = _ref.method,
            pathname = _ref.pathname,
            search = _ref.search,
            searchParams = _ref.searchParams,
            hash = _ref.hash,
            hashParams = _ref.hashParams,
            _ref$initial = _ref.initial,
            initial = _ref$initial === void 0 ? false : _ref$initial;
        return {
          method: method,
          pathname: pathname,
          search: search,
          searchParams: searchParams,
          hash: hash,
          hashParams: hashParams,
          initial: initial
        };
      }
    };
  },
  reducers: function reducers(_ref2) {
    var _ref4, _ref6, _ref8;

    var actions = _ref2.actions;
    return {
      location: [getLocationFromContext(), (_ref4 = {}, _ref4[actions.locationChanged] = function (_, _ref3) {
        var pathname = _ref3.pathname,
            search = _ref3.search,
            hash = _ref3.hash;
        return {
          pathname: pathname,
          search: search,
          hash: hash
        };
      }, _ref4)],
      searchParams: [kea.getPluginContext('router').decodeParams(getLocationFromContext().search, '?'), (_ref6 = {}, _ref6[actions.locationChanged] = function (_, _ref5) {
        var searchParams = _ref5.searchParams;
        return searchParams;
      }, _ref6)],
      hashParams: [kea.getPluginContext('router').decodeParams(getLocationFromContext().hash, '#'), (_ref8 = {}, _ref8[actions.locationChanged] = function (_, _ref7) {
        var hashParams = _ref7.hashParams;
        return hashParams;
      }, _ref8)]
    };
  },
  listeners: function listeners(_ref9) {
    var _ref10;

    var actions = _ref9.actions,
        sharedListeners = _ref9.sharedListeners;
    return _ref10 = {}, _ref10[actions.push] = sharedListeners.updateLocation, _ref10[actions.replace] = sharedListeners.updateLocation, _ref10;
  },
  sharedListeners: function sharedListeners(_ref11) {
    var actions = _ref11.actions;
    return {
      updateLocation: function updateLocation(_ref12, breakpoint, action) {
        var url = _ref12.url,
            searchInput = _ref12.searchInput,
            hashInput = _ref12.hashInput;
        var method = action.type === actions.push.toString() ? 'push' : 'replace';

        var _getPluginContext = kea.getPluginContext('router'),
            history = _getPluginContext.history;

        var response = combineUrl(url, searchInput, hashInput);
        history[method + "State"]({}, '', response.url);
        actions.locationChanged(_extends({
          method: method.toUpperCase()
        }, response));
      }
    };
  },
  events: function events(_ref13) {
    var actions = _ref13.actions,
        cache = _ref13.cache;
    return {
      afterMount: function afterMount() {
        if (typeof window === 'undefined') {
          return;
        }

        cache.listener = function (event) {
          var _getPluginContext2 = kea.getPluginContext('router'),
              location = _getPluginContext2.location,
              decodeParams = _getPluginContext2.decodeParams;

          if (location) {
            actions.locationChanged({
              method: 'POP',
              pathname: location.pathname,
              search: location.search,
              searchParams: decodeParams(location.search, '?'),
              hash: location.hash,
              hashParams: decodeParams(location.hash, '#')
            });
          }
        };

        window.addEventListener('popstate', cache.listener);
      },
      beforeUnmount: function beforeUnmount() {
        if (typeof window === 'undefined') {
          return;
        }

        window.removeEventListener('popstate', cache.listener);
      }
    };
  }
});

function getLocationFromContext() {
  var _getPluginContext3 = kea.getPluginContext('router'),
      _getPluginContext3$lo = _getPluginContext3.location,
      pathname = _getPluginContext3$lo.pathname,
      search = _getPluginContext3$lo.search,
      hash = _getPluginContext3$lo.hash;

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var urlPattern = createCommonjsModule(function (module, exports) {
// Generated by CoffeeScript 1.10.0
var slice = [].slice;

(function (root, factory) {
  if ( exports !== null) {
    return module.exports = factory();
  } else {
    return root.UrlPattern = factory();
  }
})(commonjsGlobal, function () {
  var P, UrlPattern, astNodeContainsSegmentsForProvidedParams, astNodeToNames, astNodeToRegexString, baseAstNodeToRegexString, concatMap, defaultOptions, escapeForRegex, getParam, keysAndValuesToObject, newParser, regexGroupCount, stringConcatMap, stringify;

  escapeForRegex = function (string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  concatMap = function (array, f) {
    var i, length, results;
    results = [];
    i = -1;
    length = array.length;

    while (++i < length) {
      results = results.concat(f(array[i]));
    }

    return results;
  };

  stringConcatMap = function (array, f) {
    var i, length, result;
    result = '';
    i = -1;
    length = array.length;

    while (++i < length) {
      result += f(array[i]);
    }

    return result;
  };

  regexGroupCount = function (regex) {
    return new RegExp(regex.toString() + '|').exec('').length - 1;
  };

  keysAndValuesToObject = function (keys, values) {
    var i, key, length, object, value;
    object = {};
    i = -1;
    length = keys.length;

    while (++i < length) {
      key = keys[i];
      value = values[i];

      if (value == null) {
        continue;
      }

      if (object[key] != null) {
        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }

        object[key].push(value);
      } else {
        object[key] = value;
      }
    }

    return object;
  };

  P = {};

  P.Result = function (value, rest) {
    this.value = value;
    this.rest = rest;
  };

  P.Tagged = function (tag, value) {
    this.tag = tag;
    this.value = value;
  };

  P.tag = function (tag, parser) {
    return function (input) {
      var result, tagged;
      result = parser(input);

      if (result == null) {
        return;
      }

      tagged = new P.Tagged(tag, result.value);
      return new P.Result(tagged, result.rest);
    };
  };

  P.regex = function (regex) {
    return function (input) {
      var matches, result;
      matches = regex.exec(input);

      if (matches == null) {
        return;
      }

      result = matches[0];
      return new P.Result(result, input.slice(result.length));
    };
  };

  P.sequence = function () {
    var parsers;
    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return function (input) {
      var i, length, parser, rest, result, values;
      i = -1;
      length = parsers.length;
      values = [];
      rest = input;

      while (++i < length) {
        parser = parsers[i];
        result = parser(rest);

        if (result == null) {
          return;
        }

        values.push(result.value);
        rest = result.rest;
      }

      return new P.Result(values, rest);
    };
  };

  P.pick = function () {
    var indexes, parsers;
    indexes = arguments[0], parsers = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    return function (input) {
      var array, result;
      result = P.sequence.apply(P, parsers)(input);

      if (result == null) {
        return;
      }

      array = result.value;
      result.value = array[indexes];
      return result;
    };
  };

  P.string = function (string) {
    var length;
    length = string.length;
    return function (input) {
      if (input.slice(0, length) === string) {
        return new P.Result(string, input.slice(length));
      }
    };
  };

  P.lazy = function (fn) {
    var cached;
    cached = null;
    return function (input) {
      if (cached == null) {
        cached = fn();
      }

      return cached(input);
    };
  };

  P.baseMany = function (parser, end, stringResult, atLeastOneResultRequired, input) {
    var endResult, parserResult, rest, results;
    rest = input;
    results = stringResult ? '' : [];

    while (true) {
      if (end != null) {
        endResult = end(rest);

        if (endResult != null) {
          break;
        }
      }

      parserResult = parser(rest);

      if (parserResult == null) {
        break;
      }

      if (stringResult) {
        results += parserResult.value;
      } else {
        results.push(parserResult.value);
      }

      rest = parserResult.rest;
    }

    if (atLeastOneResultRequired && results.length === 0) {
      return;
    }

    return new P.Result(results, rest);
  };

  P.many1 = function (parser) {
    return function (input) {
      return P.baseMany(parser, null, false, true, input);
    };
  };

  P.concatMany1Till = function (parser, end) {
    return function (input) {
      return P.baseMany(parser, end, true, true, input);
    };
  };

  P.firstChoice = function () {
    var parsers;
    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return function (input) {
      var i, length, parser, result;
      i = -1;
      length = parsers.length;

      while (++i < length) {
        parser = parsers[i];
        result = parser(input);

        if (result != null) {
          return result;
        }
      }
    };
  };

  newParser = function (options) {
    var U;
    U = {};
    U.wildcard = P.tag('wildcard', P.string(options.wildcardChar));
    U.optional = P.tag('optional', P.pick(1, P.string(options.optionalSegmentStartChar), P.lazy(function () {
      return U.pattern;
    }), P.string(options.optionalSegmentEndChar)));
    U.name = P.regex(new RegExp("^[" + options.segmentNameCharset + "]+"));
    U.named = P.tag('named', P.pick(1, P.string(options.segmentNameStartChar), P.lazy(function () {
      return U.name;
    })));
    U.escapedChar = P.pick(1, P.string(options.escapeChar), P.regex(/^./));
    U["static"] = P.tag('static', P.concatMany1Till(P.firstChoice(P.lazy(function () {
      return U.escapedChar;
    }), P.regex(/^./)), P.firstChoice(P.string(options.segmentNameStartChar), P.string(options.optionalSegmentStartChar), P.string(options.optionalSegmentEndChar), U.wildcard)));
    U.token = P.lazy(function () {
      return P.firstChoice(U.wildcard, U.optional, U.named, U["static"]);
    });
    U.pattern = P.many1(P.lazy(function () {
      return U.token;
    }));
    return U;
  };

  defaultOptions = {
    escapeChar: '\\',
    segmentNameStartChar: ':',
    segmentValueCharset: 'a-zA-Z0-9-_~ %',
    segmentNameCharset: 'a-zA-Z0-9',
    optionalSegmentStartChar: '(',
    optionalSegmentEndChar: ')',
    wildcardChar: '*'
  };

  baseAstNodeToRegexString = function (astNode, segmentValueCharset) {
    if (Array.isArray(astNode)) {
      return stringConcatMap(astNode, function (node) {
        return baseAstNodeToRegexString(node, segmentValueCharset);
      });
    }

    switch (astNode.tag) {
      case 'wildcard':
        return '(.*?)';

      case 'named':
        return "([" + segmentValueCharset + "]+)";

      case 'static':
        return escapeForRegex(astNode.value);

      case 'optional':
        return '(?:' + baseAstNodeToRegexString(astNode.value, segmentValueCharset) + ')?';
    }
  };

  astNodeToRegexString = function (astNode, segmentValueCharset) {
    if (segmentValueCharset == null) {
      segmentValueCharset = defaultOptions.segmentValueCharset;
    }

    return '^' + baseAstNodeToRegexString(astNode, segmentValueCharset) + '$';
  };

  astNodeToNames = function (astNode) {
    if (Array.isArray(astNode)) {
      return concatMap(astNode, astNodeToNames);
    }

    switch (astNode.tag) {
      case 'wildcard':
        return ['_'];

      case 'named':
        return [astNode.value];

      case 'static':
        return [];

      case 'optional':
        return astNodeToNames(astNode.value);
    }
  };

  getParam = function (params, key, nextIndexes, sideEffects) {
    var index, maxIndex, result, value;

    if (sideEffects == null) {
      sideEffects = false;
    }

    value = params[key];

    if (value == null) {
      if (sideEffects) {
        throw new Error("no values provided for key `" + key + "`");
      } else {
        return;
      }
    }

    index = nextIndexes[key] || 0;
    maxIndex = Array.isArray(value) ? value.length - 1 : 0;

    if (index > maxIndex) {
      if (sideEffects) {
        throw new Error("too few values provided for key `" + key + "`");
      } else {
        return;
      }
    }

    result = Array.isArray(value) ? value[index] : value;

    if (sideEffects) {
      nextIndexes[key] = index + 1;
    }

    return result;
  };

  astNodeContainsSegmentsForProvidedParams = function (astNode, params, nextIndexes) {
    var i, length;

    if (Array.isArray(astNode)) {
      i = -1;
      length = astNode.length;

      while (++i < length) {
        if (astNodeContainsSegmentsForProvidedParams(astNode[i], params, nextIndexes)) {
          return true;
        }
      }

      return false;
    }

    switch (astNode.tag) {
      case 'wildcard':
        return getParam(params, '_', nextIndexes, false) != null;

      case 'named':
        return getParam(params, astNode.value, nextIndexes, false) != null;

      case 'static':
        return false;

      case 'optional':
        return astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes);
    }
  };

  stringify = function (astNode, params, nextIndexes) {
    if (Array.isArray(astNode)) {
      return stringConcatMap(astNode, function (node) {
        return stringify(node, params, nextIndexes);
      });
    }

    switch (astNode.tag) {
      case 'wildcard':
        return getParam(params, '_', nextIndexes, true);

      case 'named':
        return getParam(params, astNode.value, nextIndexes, true);

      case 'static':
        return astNode.value;

      case 'optional':
        if (astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes)) {
          return stringify(astNode.value, params, nextIndexes);
        } else {
          return '';
        }

    }
  };

  UrlPattern = function (arg1, arg2) {
    var groupCount, options, parsed, parser, withoutWhitespace;

    if (arg1 instanceof UrlPattern) {
      this.isRegex = arg1.isRegex;
      this.regex = arg1.regex;
      this.ast = arg1.ast;
      this.names = arg1.names;
      return;
    }

    this.isRegex = arg1 instanceof RegExp;

    if (!('string' === typeof arg1 || this.isRegex)) {
      throw new TypeError('argument must be a regex or a string');
    }

    if (this.isRegex) {
      this.regex = arg1;

      if (arg2 != null) {
        if (!Array.isArray(arg2)) {
          throw new Error('if first argument is a regex the second argument may be an array of group names but you provided something else');
        }

        groupCount = regexGroupCount(this.regex);

        if (arg2.length !== groupCount) {
          throw new Error("regex contains " + groupCount + " groups but array of group names contains " + arg2.length);
        }

        this.names = arg2;
      }

      return;
    }

    if (arg1 === '') {
      throw new Error('argument must not be the empty string');
    }

    withoutWhitespace = arg1.replace(/\s+/g, '');

    if (withoutWhitespace !== arg1) {
      throw new Error('argument must not contain whitespace');
    }

    options = {
      escapeChar: (arg2 != null ? arg2.escapeChar : void 0) || defaultOptions.escapeChar,
      segmentNameStartChar: (arg2 != null ? arg2.segmentNameStartChar : void 0) || defaultOptions.segmentNameStartChar,
      segmentNameCharset: (arg2 != null ? arg2.segmentNameCharset : void 0) || defaultOptions.segmentNameCharset,
      segmentValueCharset: (arg2 != null ? arg2.segmentValueCharset : void 0) || defaultOptions.segmentValueCharset,
      optionalSegmentStartChar: (arg2 != null ? arg2.optionalSegmentStartChar : void 0) || defaultOptions.optionalSegmentStartChar,
      optionalSegmentEndChar: (arg2 != null ? arg2.optionalSegmentEndChar : void 0) || defaultOptions.optionalSegmentEndChar,
      wildcardChar: (arg2 != null ? arg2.wildcardChar : void 0) || defaultOptions.wildcardChar
    };
    parser = newParser(options);
    parsed = parser.pattern(arg1);

    if (parsed == null) {
      throw new Error("couldn't parse pattern");
    }

    if (parsed.rest !== '') {
      throw new Error("could only partially parse pattern");
    }

    this.ast = parsed.value;
    this.regex = new RegExp(astNodeToRegexString(this.ast, options.segmentValueCharset));
    this.names = astNodeToNames(this.ast);
  };

  UrlPattern.prototype.match = function (url) {
    var groups, match;
    match = this.regex.exec(url);

    if (match == null) {
      return null;
    }

    groups = match.slice(1);

    if (this.names) {
      return keysAndValuesToObject(this.names, groups);
    } else {
      return groups;
    }
  };

  UrlPattern.prototype.stringify = function (params) {
    if (params == null) {
      params = {};
    }

    if (this.isRegex) {
      throw new Error("can't stringify patterns generated from a regex");
    }

    if (params !== Object(params)) {
      throw new Error("argument must be an object or undefined");
    }

    return stringify(this.ast, params, {});
  };

  UrlPattern.escapeForRegex = escapeForRegex;
  UrlPattern.concatMap = concatMap;
  UrlPattern.stringConcatMap = stringConcatMap;
  UrlPattern.regexGroupCount = regexGroupCount;
  UrlPattern.keysAndValuesToObject = keysAndValuesToObject;
  UrlPattern.P = P;
  UrlPattern.newParser = newParser;
  UrlPattern.defaultOptions = defaultOptions;
  UrlPattern.astNodeToRegexString = astNodeToRegexString;
  UrlPattern.astNodeToNames = astNodeToNames;
  UrlPattern.getParam = getParam;
  UrlPattern.astNodeContainsSegmentsForProvidedParams = astNodeContainsSegmentsForProvidedParams;
  UrlPattern.stringify = stringify;
  return UrlPattern;
});
});

var memoryHistroy = {
  pushState: function pushState(state, _, url) {},
  replaceState: function replaceState(state, _, url) {}
};
function routerPlugin(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _history = _ref.history,
      _location = _ref.location,
      _ref$pathFromRoutesTo = _ref.pathFromRoutesToWindow,
      pathFromRoutesToWindow = _ref$pathFromRoutesTo === void 0 ? function (path) {
    return path;
  } : _ref$pathFromRoutesTo,
      _ref$pathFromWindowTo = _ref.pathFromWindowToRoutes,
      pathFromWindowToRoutes = _ref$pathFromWindowTo === void 0 ? function (path) {
    return path;
  } : _ref$pathFromWindowTo,
      _ref$encodeParams = _ref.encodeParams,
      encodeParams$1 = _ref$encodeParams === void 0 ? encodeParams : _ref$encodeParams,
      _ref$decodeParams = _ref.decodeParams,
      decodeParams$1 = _ref$decodeParams === void 0 ? decodeParams : _ref$decodeParams;

  var history = _history || (typeof window !== 'undefined' ? window.history : memoryHistroy);
  var location = _location || (typeof window !== 'undefined' ? window.location : {});
  return {
    name: 'router',
    events: {
      afterPlugin: function afterPlugin() {
        kea.setPluginContext('router', {
          history: history,
          location: location,
          encodeParams: encodeParams$1,
          decodeParams: decodeParams$1
        });
      },
      afterReduxStore: function afterReduxStore() {
        router.mount();
      },
      afterLogic: function afterLogic(logic, input) {
        if (!input.actionToUrl && !input.urlToAction) {
          return;
        }

        if (input.urlToAction) {
          logic.cache.__routerListeningToLocation = true;
        }

        logic.extend({
          connect: {
            actions: [router, ['push as __routerPush', 'locationChanged as __routerLocationChanged']],
            values: [router, ['location as __routerLocation']]
          },
          listeners: function listeners(_ref2) {
            var actions = _ref2.actions;
            var listeners = {};

            if (input.urlToAction) {
              var urlToActionMapping = input.urlToAction(logic);
              var routes = Object.keys(urlToActionMapping).map(function (pathFromRoutes) {
                return {
                  path: pathFromRoutes,
                  pattern: new urlPattern(pathFromRoutes),
                  action: urlToActionMapping[pathFromRoutes]
                };
              });

              listeners[actions.__routerLocationChanged] = function (_ref3) {
                var pathname = _ref3.pathname,
                    searchParams = _ref3.searchParams,
                    hashParams = _ref3.hashParams;
                var pathInWindow = decodeURI(pathname);
                var pathInRoutes = pathFromWindowToRoutes(pathInWindow);
                var matchedRoute;
                var params;

                for (var _iterator = routes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                  var _ref4;

                  if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref4 = _iterator[_i++];
                  } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref4 = _i.value;
                  }

                  var route = _ref4;
                  params = route.pattern.match(pathInRoutes);

                  if (params) {
                    matchedRoute = route;
                    break;
                  }
                }

                matchedRoute && matchedRoute.action(params, searchParams, hashParams);
              };
            }

            if (input.actionToUrl) {
              var _loop = function _loop() {
                var _Object$entries$_i = _Object$entries[_i2],
                    actionKey = _Object$entries$_i[0],
                    urlMapping = _Object$entries$_i[1];

                listeners[actionKey] = function (payload) {
                  var _logic$values$__route = logic.values.__routerLocation,
                      pathname = _logic$values$__route.pathname,
                      search = _logic$values$__route.search,
                      hash = _logic$values$__route.hash;
                  var currentPathInWindow = pathname + search + hash;
                  var pathInRoutes = urlMapping(payload);

                  if (typeof pathInRoutes === 'undefined') {
                    return;
                  }

                  var pathInWindow = Array.isArray(pathInRoutes) ? pathFromRoutesToWindow(pathInRoutes[0]) + stringOrObjectToString(pathInRoutes[1], '?') + stringOrObjectToString(pathInRoutes[2], '#') : pathFromRoutesToWindow(pathInRoutes);

                  if (currentPathInWindow !== pathInWindow) {
                    actions.__routerPush(pathInWindow);
                  }
                };
              };

              for (var _i2 = 0, _Object$entries = Object.entries(input.actionToUrl(logic)); _i2 < _Object$entries.length; _i2++) {
                _loop();
              }
            }

            return listeners;
          },
          events: function events(_ref5) {
            var actions = _ref5.actions,
                listeners = _ref5.listeners,
                cache = _ref5.cache;
            return {
              afterMount: function afterMount() {
                var locationChanged = actions.__routerLocationChanged;

                if (listeners && listeners[locationChanged] && cache.__routerListeningToLocation) {
                  listeners[locationChanged].forEach(function (listener) {
                    listener({
                      type: locationChanged.toString(),
                      payload: _extends({}, router.values.location, {
                        searchParams: router.values.searchParams,
                        hashParams: router.values.hashParams,
                        method: 'POP',
                        initial: true
                      })
                    });
                  });
                }
              }
            };
          }
        });
      }
    }
  };
}

exports.combineUrl = combineUrl;
exports.decodeParams = decodeParams;
exports.encodeParams = encodeParams;
exports.router = router;
exports.routerPlugin = routerPlugin;
